import { createStyles } from '@mantine/core';

import { PickVariant } from '../../types/single.pick';
import type { SingleSlate } from '../../types/single.slate';

type PickStylesProps = {
  bgColorPickStatus: string;
  borderColorPickStatus: string;
  animationBGColorPickStatus: string;
  variant: PickVariant;
} & Pick<SingleSlate, 'isLive' | 'isEliminated' | 'isUnavailable'>;

const usePickStyles = createStyles((theme, props: PickStylesProps) => ({
  root:
    props.variant === PickVariant.PICK_BAR
      ? {
          background: props.bgColorPickStatus,
          overflow: 'hidden',
          borderColor: props.animationBGColorPickStatus,
          pointerEvents: props.isEliminated || props.isUnavailable ? 'none' : 'inherit',
          opacity: props.isUnavailable ? 0.5 : 1,

          '&:hover': {
            zIndex: 2,
            background: props.bgColorPickStatus,
          },
        }
      : {
          padding: 0,
          background: 'transparent',
          overflow: 'hidden',
          pointerEvents: props.isEliminated ? 'none' : 'inherit',
          '&:hover': {
            background: 'transparent',
          },
        },
  label: {
    overflow: 'visible',
    width: '100%',
  },
  imageContainer:
    props.variant === PickVariant.PICK_BAR
      ? {}
      : {
          border: '1px solid',
          overflow: 'hidden',
          borderColor: props.borderColorPickStatus,
          background: props.bgColorPickStatus,
          padding: `${theme.spacing.xl / 8}px ${theme.spacing.md}px`,
          borderRadius: theme.spacing.xl / 8,
          height: '52px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
  stack: {
    zIndex: 2,
    position: 'relative',
    width: '100%',
  },
}));

export default usePickStyles;
